// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"2977e24e","903":"ac16a16a"}[chunkId] + ".chunk.js";
};